


















































































































import Component from 'vue-class-component'
import {
  BankAccountDataDto,
  OrderApi,
  OrderConfirmationDto,
  PaymentMethodDto,
  StripePaymentInformationDto
} from "@swagger";
import BasicComponent from "@/global/BasicComponent";
import ImageDownload from "@/components/ImageDownload.vue";
import {Prop} from "vue-property-decorator";
import PaymentMethodSelector from "@/components/PaymentMethodSelector.vue";
import {Stripe} from "@stripe/stripe-js";

@Component({
  components: {PaymentMethodSelector, ImageDownload}
})
export default class VerifyPayment extends BasicComponent {

  @Prop(String) token: string;

  orderConfirmation: OrderConfirmationDto = null;
  paymentDataValid: boolean = false;
  paymentMethod: PaymentMethodDto = null;
  paymentLoading = false;
  error: boolean = false;
  errorMsg: string = null;
  holderFirstName: string = "";
  holderLastName: string = "";
  loading: boolean = true;
  downloadCode: string = null;
  bankAccount: BankAccountDataDto|null = null;
  manualPayment: boolean = false;
  
  created() {
    this.verifyPayment();
  }

  mounted() {
    this.trackPage("Zahlung überprüfen");
  }

  get orderId() {
    return this.orderConfirmation?.orderId;
  }

  get orderAmount() {
    return this.orderConfirmation?.totalAmount;
  }

  get success() {
    return this.orderConfirmation?.success;
  }

  get hasDownloads() {
    return this.downloadCode != null;
  }

  get isLoading() {
    return this.loading && !this.isFailed && !this.payManually;
  }

  get tryAgain() {
    return window.location.toString().includes("redirect_status=canceled") || window.location.toString().includes("redirect_status=failed");
  }

  get isFailed() {
    return this.$route.query["error"] === "true" || this.$route.query["redirect_status"] === "failed";
  }

  get payManually() {
    return this.manualPayment || this.$route.query["payManually"] === "true";
  }

  get paymentInformation(): StripePaymentInformationDto {
    return this.$store.getters.paymentInformation;
  }

  get stripe(): Stripe {
    return this.$store.getters.stripe;
  }

  get stripeDataValid(): boolean {
    return this.paymentDataValid;
  }

  get hidePayButton(): boolean {
    return this.paymentMethod === PaymentMethodDto.BANKTRANSFER;
  }

  get payWithBankTransfer(): boolean {
    return this.paymentMethod === PaymentMethodDto.BANKTRANSFER;
  }

  get paymentNoticeOrderInformation(): string {
    return (this.$t("PAYMENT_NOTICE_ORDER_INFORMATION") as string)
        ?.replace("{order_id}", this.orderId)
        ?.replace("{price}", this.formatPrice(this.orderAmount));
  }

  get bankQrCodeSource(): string {
    return `/api/order/${this.token}/bank-transfer/qr-code`;
  }

  verifyPayment() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    const source = params.get("source");
    const intent = params.get("intent") || this.$route.query.intent;
    const orderToken = this.token;

    const verifyPayment = this.verifyPayment;

    new OrderApi(this.apiConfiguration).verifyPayment({
      orderToken: orderToken as string,
      paymentIntent: intent as string,
      paymentSource: source as string
    })
        .then((data: OrderConfirmationDto) => {
          this.orderConfirmation = data;
          this.downloadCode = data.downloadCode;
          this.loading = false;
          this.getBasketData(); // Basket emptied

          this.trackEvent("Bestellung", "Zahlung überprüfen");
        })
        .catch((err) => {
          if (err.json) {
            err.json().then((e: OrderConfirmationDto) => {
              this.orderConfirmation = e;
              this.bankAccount = e.bankAccount;
              this.error = true;
              if (this.payManually) {
                this.paymentMethod = PaymentMethodDto.BANKTRANSFER;
              }
              if (e.tryAgain && !this.payManually) {
                setTimeout(() => verifyPayment(), 3000);
              } else {
                this.loading = false;
                this.$store.commit("setPaymentInformation", e.stripePayment);
                const queryError = this.$route.query["error"];
                if (queryError) {
                  this.errorMsg = queryError as string;
                }
              }
            });
          } else {
            this.error = err;
            console.error(err);
          }
        });
  }

  payWithStripe() {
    if (!this.stripeDataValid) {
      return;
    }
    this.paymentLoading = true;
    this.stripe.confirmPayment({
      elements: (this.$refs.paymentMethodSelector as PaymentMethodSelector).elements,
      confirmParams: {
        return_url: this.orderConfirmation.redirectUrl,
      }
    }).then(({error}) => {
      if (error) {
        this.paymentLoading = false;
        this.errorMsg = error.message;
      }
    })
  }

  printPage() {
    window.print();
  }

}

